export const ru = {
  seeAll: 'Посмотреть все',
  usefulArticles: 'Полезные статьи {place}',
  sights: 'Достопримечательности {city}',
};
